export default {"myOddsChecker":"VIUOC"};